<template>
  
      <div style="width: 100%;background-color: #fff;">
        
        <div class="pointsBox">
          <div class="pointsTitle">新春页面</div>
          <div class="recruitmentContentBox">
            <a-list item-layout="vertical" size="large" :pagination="pagination" :data-source="dataSource">
              <template #renderItem="{ item }">
                <div class="listBox" @click="goDetail(item.id)">
                  <div class="leftBox">
                    <h3>{{ item.publishTime && item.publishTime.split(' ')[0].split('-')[2] }}</h3>
                    <h6>{{ item.publishTime && item.publishTime.split(' ')[0].split('-')[0] }}.{{ item.publishTime &&
                      item.publishTime.split(' ')[0].split('-')[1] }}</h6>
                  </div>
                  <div class="right">
                    <div class="title">{{ item.title }}</div>
                    <div class="content">{{ item.contentAbstract }}</div>
                  </div>
                </div>
              </template>
            </a-list>
          </div>
        </div>
      </div>
</template>

<script>
import { login_mp } from "@/api/adminService";
import { ls } from "@/utils/util"
import { enterpriseOperatingIncome } from "@/api/integral";
import { sys_admin, file_service, noticeInfoHome, basicsEssayInfo} from "@/api/adminService";
import { noticeInfo, getBannerInfo, getWebInfo } from "@/api/homeService";
import { platformName } from "@/config/platformConfig";
import { getDistMixin, listMixin } from "@/mixins";

const pagination = {
  pageSize: 10,
  showQuickJumper: true,
};
export default {
  name: "index",
  components: {
  },
  mixins: [ getDistMixin, listMixin],
  data() {
    return {
      pagination,
      noticeData: [],
      scrollNoticeData: [],
      fourObj: {},
      user: {},
      getDetailNoteParam: null,
      operatingIncomeScale: null,
      platformName,
      getAuditStatus: null,
      visible: false,
      getDateId: null,
      formState: {
        user: undefined,
      },
      policyNotice: {},
      bannerData: [],
      webSiteInfo: {},
      linkData: [],

      queryParam: {},
      // listUrl: noticeInfo.pageList,
      current: 1,
      pageSize: 10,
      str: null,
    }
  },
  computed: {
    listUrl() {
      
      if(this.$route.query.type == 1){
        return noticeInfoHome.pageList
      }else if(this.$route.query.type == 2){
        return noticeInfo.pageList
      }else{
        return basicsEssayInfo.pageList
      }
      
    }
  },
  methods: {
    logout() {
      let self = this;

      self.$ls.clear();
      self.$store.commit('setMenuData', []);
      self.$router.replace('/');

      location.reload();
    },
    onLogout() {
      let self = this;
      self.$confirm({
        title: '确认要退出登录?',
        content: '',
        onOk() {
          self.postAction({
            url: login_mp.saveLog,
            params: { logAppCategoryEnum: "LOGOUT" }
          }).then(res => {
            console.log(res)
            self.getAction({
              url: login_mp.logout,
              params: { access_token: ls.get("token") || "" },
              isValid: false
            }).then(() => {
              self.$notification['success']({
                message: '退出成功',
                style: {
                  fontWeight: '600',
                },
              });
            })
          })


          setTimeout(() => {
            self.logout();
          }, 2000)
        },
        onCancel() {
        },
      });
    },
    goMorePolicy() {
      this.$router.push({
        path: '/notice',
        // query: { type: "资讯公告", activeKey: 2 }
      })
    },
    goDetail(id) {
      this.$router.push({
        path: "/webNoticeDetail",
        query: { id: id,type: this.$route.query.type }
      })
    },
    getUserInfo() {
      this.getAction({
        url: sys_admin.userInfor
      }).then(res => {
        sessionStorage.setItem("roleCode", res.roleCode.split(','));
      })
    },
    getNoticeInfo() {
      this.getAction({
        url: noticeInfo.pageList,
        params: { pageNum: 1, pageSize: 10 }
      }).then(res => {
        this.noticeData = res.records
      })
    },
    getNoticeDownInfo() {
      this.getAction({
        url: noticeInfoHome.pageList,
        params: { pageNum: 1, pageSize: 10 }
      }).then(res => {
        this.scrollNoticeData = res.records
      })
    },
    goHttp(url) {
      window.open(url, '_bank')
    },
    goMore(url, str) {
      this.$router.push({ path: url, query: { id: str } })
    },
    goMoreNotice(url, str) {
      console.log('url: ', url, str)
      this.$router.push({ path: url, query: { ...str } })
    },
    getDetail() {
      this.getAction({
        url: enterpriseOperatingIncome.detail,
        params: {
          id: this.getDateId.id,
        },
        returnMsg: true,
      }).then((res) => {
        this.getDetailNoteParam = res.data
        this.operatingIncomeScale = res.data.operatingIncomeScale
        this.getAuditStatus = res.data.auditStatus
      });
    },
    getDate() {
      this.getAction({
        url: enterpriseOperatingIncome.getDate,
        // params: { id: id },
        returnMsg: true,
      }).then((res) => {
        this.getDateId = res.data
        // auditStatus
      });
    },
    islogin() {
      if (ls.get('token') && ls.get("refresh_token")) {
        if (ls.get("roleCode").includes('company')) {
          this.goMore('/sys/companyInfo')
        } else if (ls.get("roleCode").includes('technicalManager')) {
          this.goMore('/sys/technology/person');
        } else if (ls.get("roleCode").includes('serviceOrganization')) {
          this.goMore('/sys/innovation/organization/index');
        } else if (ls.get("roleCode").includes('investorManager')) {
          this.goMore('/finance/investorInformation');
        } else if (ls.get("roleCode").includes('investmentMechanism')) {
          this.goMore('/finance/investmentOrganizationInformation');
        } else if (ls.get("roleCode").includes('financialAdviser')) {
          this.goMore('/finance/financialAdvisorInformation');
        } else {
          this.goMore('/sys/userInfo')
        }
      } else {
        this.goMore('/login', 'user')
      }
    },
    getBannerList() {
      this.getAction({
        url: getBannerInfo.pageList,
        params: { type: 'home' }
      }).then(res => {
        this.bannerData = res.records.reverse()
      })
    },
    getImg(imgUrl) {
      return file_service.imagesWeb(imgUrl)
    },
    getWebInfo() {
      this.getAction({
        url: getWebInfo.detail,
        params: { id: 1 }
      }).then(res => {
        this.webSiteInfo = res
      })
    },
    beforeRouteEnter(to) {
      document.title = to;
    },
  },
  mounted() {
    
    if(this.$route.query.type == 1){
        this.beforeRouteEnter('通知专栏')
      }else if(this.$route.query.type == 2){
        this.beforeRouteEnter('政策专栏')
      }else{
        this.beforeRouteEnter('新闻专栏')
      }
    this.str = this.$route.query.type
    this.getWebInfo()
    this.getBannerList()
    // this.getDate()
    this.getNoticeDownInfo()
    if (ls.get('token') && ls.get("refresh_token")) {
      this.user.userName = this.$ls.get('userName')
      this.user.phoneNumber = this.$ls.get('phoneNumber')
    }
  }
}
</script>

<style scoped lang="less">
:deep(.ant-btn) {
  color: #fc550b;
  font-weight: 600;
  padding: 0 10px;

  img {
    margin-right: 5px
  }

  &:hover {
    border-color: #ffffff;
    box-shadow: 1px 1px 5px 1px #a7a7a7;
  }
}

.headerBox {
  width: 100%;
  height: 92px;
  background-color: #fff;

  .hearderContentBox {
    width: 1200px;
    margin: 0 auto;

    .titleBox {
      cursor: pointer;
      overflow: hidden;
      float: left;
      line-height: 92px;
      font-size: 30px;
      font-weight: bold;

      .logoBox {
        float: left;
        width: 73px;
        height: 66px;
        margin-right: 5px;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .rightBox {
      float: right;
      display: flex;
      justify-content: space-around;
      line-height: 92px;
      font-size: 16px;

      a {
        font-weight: 600;
      }

      .loginBox {
        // float: left;
        cursor: pointer;
      }

      .loginBox:hover {
        color: #fc550b;
      }

      .lineBox {
        height: 18px;
        top: 36px;
      }

      .resigierBox {
        cursor: pointer;
        // float: left;
      }

      .resigierBox:hover {
        color: #fc550b;
      }
    }
  }
}

.bannerBox {
  position: relative;
  width: 100%;

  :deep(.ant-carousel) {
    position: relative;
    width: 100%;
  }

  .bannerImg {
    width: 100%;
    height: 282px;

    img {
      width: 100%;
      object-fit: cover;
      height: 280px;
    }
  }
}

.breadBox {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
}


.cardBox {
  display: flex;
  justify-content: space-between;
  width: 1200px;
  height: auto;
  margin: 0 auto;
  // background-color: #fff;

  .smallCardBox {
    margin: 36px auto;
    height: 46px;

    .leftImg {
      float: left;
      width: 46px;
      height: 46px;
      border-radius: 50%;
    }

    .rightText {
      float: left;
      margin-left: 5px;
      line-height: 46px;

      span {
        font-size: 24px;
        color: #0048c4;
      }
    }
  }
}

.contentBox {
  margin: 0 auto 20px auto;
  width: 1200px;
  height: auto;

  .menuBox {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;

    .smallMenuBox {
      position: relative;
      padding: 24px;
      width: 19%;
      // height: 180px;
      background-color: #fff;
      cursor: pointer;
      border: 1px solid #e1f1fe;

      .menuImg {
        position: absolute;
        bottom: 10px;
        right: 6px;
      }

      .menuTitle {
        margin-bottom: 22px;
        font-size: 20px;
        font-weight: bold;
      }

      .titleInfo {
        width: 90%;
        font-size: 14px;
        color: #666;
        z-index: 11;
        position: relative;
      }

      .showMoreBtn {
        margin-top: 15px;
        background-color: #fff;
        width: 44%;
        height: 40px;
        line-height: 40px;
        text-align: center;
        opacity: 0;
      }
    }

    .smallMenuBox:hover {
      background-color: #0a2c83;
      color: #fff;
      border: none;
      -webkit-transition: all 0.3s ease 0s;
      transition: all 0.3s ease 0s;
      //border: 1px solid #ffffff;
      cursor: pointer;
      -webkit-box-shadow: 0 5px 10px 1px #d2e6ff;
      box-shadow: 0 5px 10px 1px #d2e6ff;

      .titleInfo {
        color: #fff;
      }

      .showMoreBtn {
        opacity: 1;
      }
    }
  }
}

.pointsBox {
  width: 100%;
  margin: 0 auto;
  padding: 0 0 55px 0;

  .recruitmentContentBox {
    padding: 14px 0;
    width: 100%;

    .moreList {
      float: right;
      margin-top: -21px;
      font-size: 14px;
      color: #999;
    }

    .moreList:hover {
      color: #0a2c83;
      cursor: pointer;
    }

    .listBox {
      position: relative;
      overflow: hidden;
      padding: 10px 0;
      cursor: pointer;
      border-bottom: 1px solid #dedede;

      .leftBox {
        float: left;
        width: 80px;
        height: 80px;
        text-align: center;
      }

      .right {
        float: left;
        margin-left: 2%;
        width: 74%;
        font-size: 14px;

        .title {
          padding: 10px 0;
          font-size: 16px;
          color: #333;
          font-weight: 500;
        }

        .content {
          overflow: hidden;
          margin: 10px 0;
          color: #666;
          text-overflow: ellipsis;
          -o-text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }
  }

  .pagination {
    text-align: center;
    margin-bottom: 20px;
  }
}

.linkBig {
  width: 100%;
  background-color: #fff;

  .linkBox {
    overflow: hidden;
    font-size: 16px;
    color: #333;
    width: 100%;
    margin: 0 auto;
    padding: 20px 0;


    .leftLabel {
      float: left;
      width: 7%;
      font-weight: bold;
    }

    .rightBox {
      float: left;
      margin-left: 15px;
      width: 90%;
      // display: flex;
      // justify-items: start;
      // flex-wrap: wrap;

      .itemLink {
        float: left;
        margin-right: 30px;
        margin-bottom: 5px;
        color: #333;
        // text-decoration: underline;
      }

      .itemLink:hover {
        color: #0a2c83;
      }
    }
  }
}

.footerBox {
  width: 100%;
  background-color: #333333;

  .footerContent {
    position: relative;
    margin: 0 auto;
    padding: 24px 0;
    width: 1200px;

    .firstLine {
      padding: 8px 0;
      font-size: 14px;
      color: #999;

      span {
        margin-right: 18px;
      }
    }

    .footCode {
      position: absolute;
      right: 0;
      bottom: 12%;
      text-align: center;

      .footEwm {
        margin-bottom: 8px;
      }

      .footEwmTitle {
        color: #999;
      }
    }
  }
}

:deep(.ant-list-lg .ant-list-item) {
  padding: 16px 8px;
}
:deep(.ant-list-pagination){
  text-align: center;
}
</style>
